import React, { useEffect,useRef, useState } from 'react'
import { Box,Checkbox,IconButton, Image,Flex, FormLabel, Grid, GridItem, Heading, Input, InputGroup, InputRightElement, Select, Spacer, Switch, Text, Tooltip } from '@chakra-ui/react'
import CustomButton from '../../elements/customButton';
import UploadIcon from '../../../assets/images/upload.svg'
import CustomToast from '../../elements/customToast';
import DownloadIcon from '../../../assets/images/download.png'

// import GEO_LOCATION_WEB_KEY from '../../../constants/Constant'
import { Document, Page, pdfjs } from 'react-pdf';
import { ActionCreators } from '.././../../redux/actions'
import { connect, useSelector } from 'react-redux';
import { CheckCircleIcon, InfoOutlineIcon } from '@chakra-ui/icons';
import { bindActionCreators } from 'redux';
import Loader from '../../elements/loader';
import { DIGI_LOCKER_SDK,GEO_LOCATION_WEB_KEY} from '../../../constants/Constant';
import Multiselect from 'multiselect-react-dropdown';
import InstitutionalPan from './InstitutionalPan';
import KycLoanDetails from './KycLoanDetails';
import { searchPinCode, verifyPanCard ,verifyGSTNUM} from '../../../services/masterServices';
import { getKycEmailOtp, verifyKycEmailOtp } from '../../../services/kycServices';
import { getMobileOTP,verifyMobileOTP } from '../../../services/authServices';
import { getItem, setItem } from '../../../utilities/authUtils';
import { preventInvalidKey, validateAlphaNumeric, validateMobileNumber } from '../../../utilities/CustomFunctions';
import UserCurrentLocation from '../../elements/UserCurrentLocation';

const dd =GEO_LOCATION_WEB_KEY
const genderData = [
  {
    id: 'M',
    name: 'Male'
  },
  {
    id: 'F',
    name: 'Female'
  },
]

const PersonalDetails = (props) => {
  const { addToast } = CustomToast()
  const kycState = useSelector((state) => state.kycState)
  const masterState = useSelector((state) => state.masterState)
  const authState = useSelector((state) => state.authState)
  const [requestIdUser, setRequestIdUser] = useState(null)
  const [requestIdAddhaarUser, setRequestIdAddhaarUser] = useState(null)
  const [inputValues, setInputValues] = useState({})
  const [checkSwitch, setCheckSwitch] = useState(false)
  const [checkAddress, setCheckAddress] = useState(false)
  const [checkAddharnum, setCheckAddharnum] = useState(false)
  const [gstVerify, setGstVerify] = useState(null)
  const [checkBusinessAddress, setCheckBusinessAddress] = useState(false)
  const [otpStatus, setOtpStatus] = useState(null)
  const [verifyStatus, setVerifyStatus] = useState(null)
  const [panData, setPanData] = useState(null)
  const [gstData, setGStData] = useState(null)
  const [timerCount, setTimerCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const [aadhaarVerified, setAadhaarVerified] = useState(null)
  const [investmentValue, setInvestmentValue] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isgetotp, setIsgetotp] = useState(false)
  const [isgetotp_adhaar, setIsgetotp_adhaar] = useState(false)
  const [otpfield, setOtpfield] = useState(false)
  const [adhaarotpfield, setAdhaarOtpfield] = useState(false)
  const [mobilefield, setmobilefield] = useState(false)
  const [adhaarmobilefield, setAdhaarmobilefield] = useState(false)
  const [checkanothermob, setCheckanothermob] = useState(false)
  const [checkadharmob, setCheckadharmob] = useState(false)
  const [mobileData, setMobileData] = useState(null)
  const [adhaarmobileData, setAdhaarMobileData] = useState(null)
  const { navigatorFun, currentLocation,showPermissionPopup } =UserCurrentLocation();
  const [checkfieldAddharnum, setCheckfieldAddharnum] = useState(false);
  const [displayCurrentAddressField, setDisplayCurrentAddressField] = useState(false);
  const [isCurrentSame, setIsIsCurrentSame] = useState(false);
  const [pageNumber, setPageNumber] = useState(1)
  const [pincodeField, setPincodeField] = useState(false);
  const savedLocation = sessionStorage.getItem('userLocation');
  const geo_permission = sessionStorage.getItem('geo_permission');
  const [anotheradd_details, setAnotheradd_details] = useState(
    props?.userData?.alternate_details?.length > 0
      ? props.userData.alternate_details
      : [{
          alternate_mobile: '',
          alternate_addressline1: '',
          alternate_addressline2: '',
          alternate_address_district: '',
          alternate_address_state: '',
          alternate_address_pincode: '',
          alternate_relationship: '',
          alternate_name:''
        }]
  );




  let requestId = kycState?.createDigiLocker?.data?.request_id
  let email = props?.userData?.email
  const dropdownData = masterState?.getDropdownData?.data?.data
  const aadhaarAddress = {
    address_state: props?.userData?.aadhar_card_data?.address_state,
    address_district: props?.userData?.aadhar_card_data?.address_district,
    address_pincode:props?.userData?.aadhar_card_data?.address_pincode
  };
  const digioSdkInstantiation = async () => {
    try {
      const options = {
        environment:  "production",
        callback: async function (response) {
          if (response.hasOwnProperty("error_code")) {
            
            setLoading(false);
            setAadhaarVerified(null)
          } else {
            setAadhaarVerified(response)
          }
        },
        is_iframe: true,
        Is_redirection_approach: false,
        theme: {
          primaryColor: "#000",
          secondaryColor: "#000000"
        }
      };
      var digio = new window.Digio(options);
      digio.init();
      digio.submit(requestId, email);
    } catch (error) {
      console.error("Error in digioSdkInstantiation:", error);
    }
  };

  const investmentTypeKeys = props?.userData?.preference_data?.investment_type.split(',');
  const investmentTypeValues = props?.userData?.preference_data?.pref_investment_types.split(',');

  const selectedValues = investmentTypeKeys?.map((key, index) => {
   return { key, value: investmentTypeValues[index] };
  });

  useEffect(() => {
    const script = document.createElement("script");
    script.src = DIGI_LOCKER_SDK;
    script.async = true;
    document.body.appendChild(script);
    props.actions.getDropdownDataAction({ type: 'premise_status|educational_qualification|loan_type|loan_tenure|risk_appetite|relationship|buss_premise_ownership|company_sector',platform:"web",employment_type:props?.userData?.employment_type})
  }, [])
  useEffect(() => {
    const shouldCheck =
      props?.userData?.personal_data?.status === 1 &&
      !props?.userData?.personal_data?.current_pincode &&
      aadhaarAddress?.address_pincode &&
      aadhaarAddress?.address_state &&
      aadhaarAddress?.address_district &&
      currentLocation?.pincode &&
      currentLocation?.state &&
      currentLocation?.district;
  
    if (shouldCheck || geo_permission=='denied') {
      currentAddressMatch();
    }
  }, [
    props?.userData?.personal_data?.status,
    aadhaarAddress?.address_pincode,
    aadhaarAddress?.address_state,
    aadhaarAddress?.address_district,
    currentLocation?.pincode,
    currentLocation?.state,
    currentLocation?.district
  ])
  useEffect(() => {
    if(!savedLocation || props?.userData?.personal_data?.current_address_proof) {
      navigatorFun();
    }
  
  }, []);

     const  currentAddressMatch  = async()=>{
      if (
        currentLocation && aadhaarAddress) {
        const match =
          (aadhaarAddress.address_district) === currentLocation.district &&
          aadhaarAddress.address_state === currentLocation.state &&
          aadhaarAddress.address_pincode === currentLocation.pincode;
  
        if (!match) {
          addToast({ message: " Your Current Location Is Not  Match Please Fill Your Current Address", status: 'error' });
          setDisplayCurrentAddressField(true);
        } 
        else if (match){
          setIsIsCurrentSame(true)
          setInputValues({
            ...inputValues,
            current_pincode: currentLocation.pincode,
            current_city:  currentLocation.district ,
            current_state: currentLocation.state,
          });
          addToast({ message: " Your Current Location Is Matches Successfully", status: 'success' });
          setDisplayCurrentAddressField(false);
        }
      }
    }

  useEffect(() => {
    let formData = {
      ...inputValues,
      email: props?.userData?.email,
      pan: props?.userData?.pan,
      dob: props?.userData?.dob,
      first_name: props?.userData?.first_name,
      last_name: props?.userData?.last_name,
      middle_name: props?.userData?.middle_name,
      premise_status: props?.userData?.personal_data?.premise_status,
      educational_qualification: props?.userData?.personal_data?.educational_qualification,
      aadhar_number: props?.userData?.aadhar_card_data?.aadhar_number,
      fatherName: props?.userData?.aadhar_card_data?.fatherName,
      address_district: props?.userData?.aadhar_card_data?.address_district,
      address_houseNumber: props?.userData?.aadhar_card_data?.address_houseNumber,
      address_pincode: props?.userData?.aadhar_card_data?.address_pincode,
      address_state: props?.userData?.aadhar_card_data?.address_state,
      address_subdistrict: props?.userData?.aadhar_card_data?.address_subdistrict,
      gender: props?.userData?.aadhar_card_data?.gender,
      otp: props?.userData?.email ? true : false,
      pref_amount: props?.userData?.preference_data?.amount,
      pref_risk_appetite: props?.userData?.preference_data?.risk_appetite,
      pref_tenure: props?.userData?.preference_data?.tenure,
      // legal_name: props?.userData?.legal_name,
      current_address: props?.userData?.personal_data?.current_address,
      current_addressline2: props?.userData?.personal_data?.current_addressline2,
      current_city: props?.userData?.personal_data?.current_city,
      current_pincode: props?.userData?.personal_data?.current_pincode,
      current_state: props?.userData?.personal_data?.current_state,
      legal_name: props?.userData?.legal_name,
      aadhar_dob: props?.userData?.aadhar_card_data?.dob,
      aadhar_mobile_number: props?.userData?.personal_data?.aadhar_mobile_number,
      is_aadhar_mobile_num_same: props?.userData?.personal_data?.is_aadhar_mobile_num_same,
      gst: props?.userData?.gst,
      is_current_address_same: props?.userData?.personal_data?.is_current_address_same,
      company_reg_address: props?.userData?.personal_data?.company_reg_address,
      company_reg_pincode: props?.userData?.personal_data?.company_reg_pincode,
      company_reg_state: props?.userData?.personal_data?.company_reg_state,
      company_buss_state: props?.userData?.personal_data?.company_buss_state,
      company_buss_pincode: props?.userData?.personal_data?.company_buss_pincode,
      company_buss_address: props?.userData?.personal_data?.company_buss_address,
      is_business_address_same:props?.userData?.personal_data?.is_business_address_same,
      registered_address:gstData?.registered_address ?? props?.userData?.gst_detail?.registered_address,
      pincode:gstData?.pincode ?? props?.userData?.gst_detail?.pincode,
      state:gstData?.state ?? props?.userData?.gst_detail?.state,
      company_buss_sector:props?.userData?.personal_data?.company_buss_sector,
      alternate_addressline1:anotheradd_details[0]?.address_line1  ,
      alternate_addressline2:anotheradd_details[0]?.address_line2  ,
      alternate_address_district:anotheradd_details[0].address_district  ,
      alternate_address_state:anotheradd_details[0]?.address_state  ,
      alternate_address_pincode: anotheradd_details[0]?.address_pincode  ,
      alternate_relationship:anotheradd_details[0]?.relationship  ,
      alternate_name: anotheradd_details[0]?.name,
      alternate_mobile: anotheradd_details[0].mobile,
      platform:props?.userData?.platform,
      isMobile:props?.userData?.isMobile,
    }
    setInputValues(JSON.parse(JSON.stringify(formData)))
    setCheckanothermob(anotheradd_details[0]?.mobile ? true :false) 
    setCheckadharmob(props?.userData?.personal_data?.aadhar_mobile_number ? true :false) 
    // setIsCurrentUpload((props?.userData?.personal_data?.current_address_proof || inputValues?.checkAddress ===true ) ? true : false )
    if (props?.userData?.preference_data?.investment_type) {
      setInvestmentValue(props?.userData?.preference_data?.investment_type)
    }
    if ((props?.userData?.personal_data?.status ==1 || props?.userData?.personal_data?.is_current_address_same ==1))  {
      setCheckAddress(props?.userData?.personal_data?.is_current_address_same) 
    }
    if ((props?.userData?.personal_data?.current_address_proof || props?.userData?.personal_data?.status ==1 || props?.userData?.personal_data?.is_current_address_same==1 || props?.userData?.aadhar_card_data)) {
      setDisplayCurrentAddressField(true)
    }
    
    if (props?.userData?.personal_data?.is_aadhar_mobile_num_same) {
      setCheckAddharnum(props?.userData?.personal_data?.is_aadhar_mobile_num_same)
    }
    if (props?.userData?.personal_data?.is_business_address_same) {
      setCheckBusinessAddress(props?.userData?.personal_data?.is_business_address_same)
    }
  }, [props?.userData])

  useEffect(() => {
    if (requestId && email) {
      digioSdkInstantiation()
      props?.actions?.cleanUpToast()
      props.actions.getDropdownDataAction({ type: 'premise_status|educational_qualification|loan_type|loan_tenure|risk_appetite|relationship|buss_premise_ownership|company_sector|relationship',platform:"web",employment_type:props?.userData?.employment_type})
    }
  }, [requestId, email])
 
  useEffect(() => {
    if (kycState?.postPersonalDetails?.data?.success === true) {
      addToast({ message: kycState?.postPersonalDetails?.data?.message, status: 'success' })
      props?.actions?.cleanUpToast()
      props?.actions?.getCurrentUserDetailsAction()
      props.onClick()
    } else if (kycState?.postPersonalDetails?.data?.success === false) {
      addToast({ message: kycState?.postPersonalDetails?.data?.message, status: 'error' })
      props.actions.getDropdownDataAction({ type: 'premise_status|educational_qualification|loan_type|loan_tenure|risk_appetite|relationship|buss_premise_ownership|company_sector'})
      props?.actions?.cleanUpToast()
    }
  }, [kycState?.postPersonalDetails])

  useEffect(() => {
    if (aadhaarVerified?.digio_doc_id) {
      addToast({ message: aadhaarVerified?.message, status: 'success' })
      props?.actions?.getDownloadAadharDataAction({ request_id: aadhaarVerified?.digio_doc_id })
      props.actions.getDropdownDataAction({ type: 'premise_status|educational_qualification|loan_type|loan_tenure|risk_appetite|relationship|buss_premise_ownership|company_sector',platform:"web",employment_type:props?.userData?.employment_type})
    }
  }, [aadhaarVerified])

  useEffect(() => {
    // if (kycState?.getdownloadAadhaarData?.error?.success === false) {
    //   props?.actions?.getDownloadAadharDataAction({ request_id: aadhaarVerified?.digio_doc_id })
    //   props.actions.getDropdownDataAction({ type: 'premise_status|educational_qualification|loan_type|loan_tenure|risk_appetite|relationship|buss_premise_ownership|company_sector|relationship',platform:"web",employment_type:props?.userData?.employment_type})
    // } else if (kycState?.getdownloadAadhaarData?.data?.success === true) {
    //   return
    // }
    const runCheck = async () => {
      // setIsLoading(true)
      if (kycState?.getdownloadAadhaarData?.error?.success === false) {
        setIsLoading(false)
        props?.actions?.getDownloadAadharDataAction({
          request_id: aadhaarVerified?.digio_doc_id
        });
        props.actions.getDropdownDataAction({
          type: 'premise_status|educational_qualification|loan_type|loan_tenure|risk_appetite|relationship|buss_premise_ownership|company_sector|relationship',
          platform: "web",
          employment_type: props?.userData?.employment_type
        });
      } else if (kycState?.getdownloadAadhaarData?.data?.success === true) {
        setIsLoading(false)
        await currentAddressMatch(); 
      }
    };
  
    runCheck(); 
  }, [kycState?.getdownloadAadhaarData])

  useEffect(() => {
    let timer;
    if (timerCount > 0) {
      timer = setTimeout(() => setTimerCount(timerCount - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [timerCount])

 

  const premiseStatusOptions = dropdownData?.premise_status

  const qualificationsOptions = dropdownData?.educational_qualification
  const investmentType = dropdownData?.loan_type
  const loanTenure = dropdownData?.loan_tenure
  const riskAppetite = dropdownData?.risk_appetite
  const relationwithuser = dropdownData?.relationship
  const userType = props?.userData?.usertype

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'otp') {
      const truncatedOTP = value.slice(0, 6);
      setInputValues({ ...inputValues, [name]: truncatedOTP });
      if (truncatedOTP.length === 6) {
        let otpData = {
          email: inputValues?.email,
          otp: truncatedOTP
        }
        setIsLoading(true)
        verifyKycEmailOtp(otpData).then((res) => {
            setIsLoading(false)
            if (res?.data?.success === true) {
                setVerifyStatus(res?.data?.success)
                addToast({ message: res?.data?.message, status: 'success' })
                setTimerCount(0)
                props.actions.getCurrentUserDetailsAction()
            } else if (res?.data?.success === false) {
              addToast({message: res?.data?.message, status: 'error'})
            }
          }).catch((error) => {
            addToast({message: error, status: 'error'})
            setIsLoading(false)
        })
      }
    } 
    else if (name === 'alternate_mobile') {
      const validValue = validateMobileNumber(value, addToast);
      if (validValue !== null) {
        setInputValues({ ...inputValues, [name]: validValue });
      }
    } 
    else if (name === 'mobile_otp') {
      const truncatedOTP = value.slice(0, 6);
      setInputValues({ ...inputValues, [name]: truncatedOTP });
    
      if (truncatedOTP.length === 6) {
        const verifiedData = {
          otp: truncatedOTP,
          mobile: inputValues.alternate_mobile,
          platform: 'web',
          user_device_id: 'NA',
          request_id: requestIdUser,
          alternate_mobile:inputValues.alternate_mobile
        };
        // props.actions.verifymobileOTPAction(verifiedData);
          // props.actions.getMobileOTPAction({mobile: inputValues.alternate_mobile})
          verifyMobileOTP(verifiedData).then((res) => {
            setMobileData(res?.data)
        setIsLoading(false)
        if (res?.data?.status === true) {
          addToast({message: res?.data?.message, status: 'success'})
          setCheckanothermob(true)
          setIsgetotp(false)
          setTimerCount(0)
          setLoading(false)
        } else if (res?.data?.status === false) {
          setLoading(false)
            addToast({message: res?.data?.message, status: 'error'})
        }
    }).catch((error) => {
        addToast({message: error, status: 'error'})
        setIsLoading(false)
    })
      }
    }
    else if (name === 'adhaarmobile_otp') {
      const truncatedOTP = value.slice(0, 6);
      setInputValues({ ...inputValues, [name]: truncatedOTP });
    
      if (truncatedOTP.length === 6) {
        const verifiedData = {
          otp: truncatedOTP,
          mobile: inputValues.aadhar_mobile_number,
          platform: 'web',
          user_device_id: 'NA',
          request_id: requestIdAddhaarUser,
          aadhar_mobile_number:inputValues.aadhar_mobile_number
        };
        // props.actions.verifymobileOTPAction(verifiedData);
          // props.actions.getMobileOTPAction({mobile: inputValues.alternate_mobile})
          verifyMobileOTP(verifiedData).then((res) => {
            setAdhaarMobileData(res?.data)
        setIsLoading(false)
        if (res?.data?.status === true) {
          addToast({message: res?.data?.message, status: 'success'})
          setCheckadharmob(true)
          setIsgetotp_adhaar(false)
          setTimerCount(0)
          setLoading(false)
        } else if (res?.data?.status === false) {
          setLoading(false)
            addToast({message: res?.data?.message, status: 'error'})
        }
    }).catch((error) => {
        addToast({message: error, status: 'error'})
        setIsLoading(false)
    })
      }
    }
    else if (name =="dob"){
      const format_dob_change= value.replace(/\//g, "-")
      setInputValues({...inputValues,[name]:format_dob_change})
    }
    else if (name === 'fatherName') {
      const validValue = validateAlphaNumeric(value, addToast);
      if (validValue !== null) {
        setInputValues({ ...inputValues, [name]: validValue });
      }
     
    } else if (name === 'pan') {
      const truncatedPAN = value.slice(0, 10);
      setInputValues({ ...inputValues, [name]: truncatedPAN.toUpperCase() });
    }
     else if (name === 'address_pincode') {
      const truncatedPinCode = value.slice(0, 6);
      setInputValues({ ...inputValues, [name]: truncatedPinCode });
      if (truncatedPinCode.length === 6) {
        setIsLoading(true)
        searchPinCode({pincode: truncatedPinCode}).then((res) => {
            setIsLoading(false)
            if (res?.data?.success === true && res?.data?.status === true) {
              setInputValues({...inputValues, address_pincode: truncatedPinCode, address_district: res?.data?.data[0]?.Districtname ?? '', address_state: res?.data?.data[0]?.statename ?? ''})
            } else if (res?.data?.success === false && res?.data?.status === false) {
              addToast({message: 'Invalid Pincode', status: 'error'})
            }
          }).catch((error) => {
            addToast({message: error, status: 'error'})
            setIsLoading(false)
        })
      }
    }
    else if (name === 'aadhar_mobile_number' && !inputValues?.is_aadhar_mobile_num_same) {
      const truncatedPinCode = value.slice(0, 10);
      // const updatedValues = {
      //   ...inputValues,
      //   [name]: isSame,
      // }
      setInputValues({ ...inputValues, [name]: truncatedPinCode });
      if (truncatedPinCode.length === 10) {
        setCheckfieldAddharnum(true)
      }
      else{
        setCheckfieldAddharnum(false)
      }
    }
    else if (name === 'alternate_address_pincode') {
      const truncatedPinCode = value.slice(0, 6);
      setInputValues({ ...inputValues, [name]: truncatedPinCode });
      if (truncatedPinCode.length === 6) {
        setIsLoading(true)
        searchPinCode({pincode: truncatedPinCode}).then((res) => {
            setIsLoading(false)
            if (res?.data?.success === true && res?.data?.status === true) {
              setInputValues({...inputValues, alternate_address_pincode: truncatedPinCode, alternate_address_district: res?.data?.data[0]?.Districtname ?? '', alternate_address_state: res?.data?.data[0]?.statename ?? ''})
            } else if (res?.data?.success === false && res?.data?.status === false) {
              addToast({message: 'Invalid Pincode', status: 'error'})
            }
          }).catch((error) => {
            addToast({message: error, status: 'error'})
            setIsLoading(false)
        })
      }
    }
    else if (name === 'gst') {
      const truncatedGST = value.slice(0, 15);
      if(props?.userData?.employment_type == "8" || props?.userData?.employment_type == "9" || props?.userData?.employment_type == "10" ){
    if (truncatedGST.length === 15) {
      let param ={
        gstin:truncatedGST,
        consent:"Y"
      }
      setIsLoading(true)
      verifyGSTNUM(param).then((res) => {
        setIsLoading(true)
        if (res?.data?.success === true) {
          setIsLoading(false)
            addToast({ message: res?.data?.message, status: 'success' })
            setGStData(res?.data?.data)
            setInputValues({...inputValues,
              registered_address:res?.data?.data?.registered_address,
              state:res?.data?.data?.state,
              pincode:res?.data?.data?.pincode,
              gst: truncatedGST
            })
      props.actions.getDropdownDataAction({ type: 'premise_status|educational_qualification|loan_type|loan_tenure|risk_appetite|relationship|buss_premise_ownership|company_sector',platform:"web",employment_type:props?.userData?.employment_type})

        } else if (res?.data?.success === false) {
            addToast({message: res?.data?.message, status: 'error'})
            setIsLoading(false)
      props.actions.getDropdownDataAction({ type: 'premise_status|educational_qualification|loan_type|loan_tenure|risk_appetite|relationship|buss_premise_ownership|company_sector',platform:"web",employment_type:props?.userData?.employment_type})

        }
        }).catch((error) => {
        addToast({message: error, status: 'error'})
        setIsLoading(false)
    })
    } 
  }
 else{
    setInputValues({ ...inputValues, [name]: truncatedGST })
 }
 
}
else if (name === 'current_pincode') {
  const truncatedPinCode = value.slice(0, 6);
  setInputValues({ ...inputValues, [name]: truncatedPinCode });

  if (truncatedPinCode.length === 6) {
    if (truncatedPinCode === currentLocation.pincode) {
      setIsLoading(true);
      setCheckAddress(true);
      setPincodeField(true)
      addToast({ message: " Current Pincode Matches Sucessfully", status: 'success' });
      searchPinCode({ pincode: truncatedPinCode })
        .then((res) => {
          setIsLoading(false);

          if (res?.data?.success === true) {
            setInputValues({
              ...inputValues,
              current_pincode: truncatedPinCode,
              current_city: res?.data?.data?.[0]?.Districtname ?? '',
              current_state: res?.data?.data?.[0]?.statename ?? ''
            });
          } else {
            addToast({ message: " Not Found", status: 'error' });
          }
        })
        .catch((error) => {
          setIsLoading(false);
          addToast({message: error, status: 'error'})
        });
    } else if(truncatedPinCode !== currentLocation.pincode){
      addToast({ message: "Current Address pincode does not match with your location pincode.", status: 'error' });
    }  
  }
} else if (name === 'company_buss_pincode') {
      const truncatedPinCode = value.slice(0, 6);
      setInputValues({ ...inputValues, [name]: truncatedPinCode });
      if (truncatedPinCode.length === 6) {
        setIsLoading(true)
        searchPinCode({pincode: truncatedPinCode}).then((res) => {
          setIsLoading(false)
          if (res?.data?.success === true) {
            setInputValues({...inputValues, company_buss_pincode: truncatedPinCode, company_buss_state: res?.data?.data[0]?.statename ?? ''})
          } else if (res?.data?.success === false) {
            addToast({message: "Not Found", status: 'error'})
          }
        }).catch((error) => {
          addToast({message: error, status: 'error'})
          setIsLoading(false)
        })
      }
    } else if (name === 'company_reg_pincode') {
      const truncatedPinCode = value.slice(0, 6);
      setInputValues({ ...inputValues, [name]: truncatedPinCode });
      if (truncatedPinCode.length === 6) {
        setIsLoading(true)
        searchPinCode({pincode: truncatedPinCode}).then((res) => {
          setIsLoading(false)
          if (res?.data?.success === true) {
            setInputValues({...inputValues, company_reg_pincode: truncatedPinCode, company_reg_state: res?.data?.data[0]?.statename ?? ''})
          } else if (res?.data?.success === false) {
            addToast({message: "Not Found", status: 'error'})
          }
        }).catch((error) => {
          addToast({message: error, status: 'error'})
          setIsLoading(false)
        })
      }
    }else if (name === 'pincode') {
      const truncatedPinCode = value.slice(0, 6);
      setInputValues({ ...inputValues, [name]: truncatedPinCode });
      if (truncatedPinCode.length === 6) {
        setIsLoading(true)
        searchPinCode({pincode: truncatedPinCode}).then((res) => {
          setIsLoading(false)
          if (res?.data?.success === true) {
            setInputValues({...inputValues, pincode: truncatedPinCode, state: res?.data?.data[0]?.statename ?? ''})
          } else if (res?.data?.success === false) {
            addToast({message: "Not Found", status: 'error'})
          }
        }).catch((error) => {
          addToast({message: error, status: 'error'})
          setIsLoading(false)
        })
      }
    }
    else if (name === 'registered_address') {
      setInputValues({ ...inputValues, registered_address:value});

    }
    else {
      setInputValues({ ...inputValues, [name]: value });
    }
  }
  const mobilehandleOTP = () => {

    ///later add validation for aadrrees match succfuuly becuase timerset noth same
    if ((inputValues?.aadhar_mobile_number?.length !== 10 && inputValues?.is_aadhar_mobile_num_same ===false )) {
      addToast({message: 'Please Add Your Aadhaar Mobile number First', status: 'error'})
      return
    }
    if (inputValues?.alternate_mobile?.length !== 10) {
      addToast({message: ' Please Enter Valid Mobile Number', status: 'error'})
    } else if (inputValues?.alternate_mobile?.length === 10) {
      let data_otp ={
        mobile: inputValues.alternate_mobile
      }
      getMobileOTP(data_otp).then((res) => {
        setIsLoading(false)
        if (res?.data?.status === true) {
            addToast({message: res?.data?.message, status: 'success'})
            setRequestIdUser(res?.data?.request_id)
            setOtpfield(true)
            setIsgetotp(true)
        
            setmobilefield(true)
            setTimerCount(120);
        } else if (res?.data?.status === false) {
            addToast({message: res?.data?.message, status: 'error'})
        }
    }).catch((error) => {
        addToast({message: error, status: 'error'})
        setIsLoading(false)
    })
    }
  }
  const adhaarhandleOTP = () => {
    if (inputValues?.aadhar_mobile_number?.length !== 10) {
      addToast({message: ' Please Enter Valid  Aadhaar Mobile Number', status: 'error'})
    } else if (inputValues?.aadhar_mobile_number?.length === 10) {
      let data_otp ={
        mobile: inputValues.aadhar_mobile_number
      }
      getMobileOTP(data_otp).then((res) => {
        setIsLoading(false)
        if (res?.data?.status === true) {
            addToast({message: res?.data?.message, status: 'success'})
            setRequestIdAddhaarUser(res?.data?.request_id)
            setAdhaarOtpfield(true)
            setIsgetotp_adhaar(true)
            setAdhaarmobilefield(true)
            setTimerCount(120);
        } else if (res?.data?.status === false) {
            addToast({message: res?.data?.message, status: 'error'})
        }
    }).catch((error) => {
        addToast({message: error, status: 'error'})
        setIsLoading(false)
    })
    }
  }
  const handleMobResendOTP = () => {
    props.actions.getMobileOTPAction({ mobile: inputValues.alternate_mobile })
    setTimerCount(120);
  }
  const handlAadharMobResendOTP = () => {
    props.actions.getMobileOTPAction({ mobile: inputValues.alternate_mobile })
    setTimerCount(120);
  }
  const handleOTP = () => {
   
    let data = {
      email: inputValues?.email,
      checkType: true,
    }
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!inputValues?.email || !emailPattern.test(inputValues.email)) {
      addToast({ message: 'Please Enter a Valid Email', status: 'error' })
      return
    }
    if (inputValues?.email) {
      setIsLoading(true)
      getKycEmailOtp(data).then((res) => {
        setIsLoading(false)
        if (res?.data?.success === true) {
          setOtpStatus(res?.data?.success)
          addToast({ message: res?.data?.message, status: 'success' })
          setTimerCount(120);
        } else if (res?.data?.success === false) {
          addToast({message: res?.data?.message, status: 'error'})
        }
        }).catch((error) => {
          addToast({message: error, status: 'error'})
          setIsLoading(false)
      })
    }
  }

  const handleResendOTP = () => {
    let data = {
      email: inputValues?.email,
      checkType: true,
    }
    setIsLoading(true)
    getKycEmailOtp(data).then((res) => {
        setIsLoading(false)
        if (res?.data?.success === true) {
            setOtpStatus(res?.data?.success)
            addToast({ message: res?.data?.message, status: 'success' })
            setTimerCount(120);
        } else if (res?.data?.success === false) {
            addToast({message: res?.data?.message, status: 'error'})
        }
        }).catch((error) => {
        addToast({message: error, status: 'error'})
        setIsLoading(false)
    })
  }

  const handleVerifyPan = () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(inputValues?.email)) {
      addToast({ message: 'Please Enter a Valid Email', status: 'error' })
      return
    }
    if (!inputValues?.first_name) {
      addToast({ message: 'Please Enter your first name', status: 'error' })
      return
    }
    if(props?.userData?.employment_type == 4 || props?.userData?.employment_type == 5 || props?.userData?.employment_type ==  '10' || props?.userData?.employment_type ==  '8'  )
    if (!inputValues?.legal_name) {
      addToast({ message: 'Please Enter Your Authorizer Name', status: 'error' })
      return
    }
    if (!inputValues?.dob) {
      addToast({ message: 'Please Enter Your Date Of Birth', status: 'error' })
      return
    }
  
    if (inputValues?.pan?.length === 10) {
      let panCardData = {
        first_name: inputValues?.first_name,
        middle_name: inputValues?.middle_name,
        last_name: inputValues?.last_name,
        dob: inputValues?.dob,
        pan: inputValues?.pan
      }
      setIsLoading(true)
      verifyPanCard(panCardData).then((res) => {
        setIsLoading(false)
        if (res?.data?.success === true) {
            addToast({ message: res?.data?.message, status: 'success' })
            setPanData(res?.data?.data)
            props.actions.getCurrentUserDetailsAction()
            props.actions.getDropdownDataAction({ type: 'premise_status|educational_qualification|loan_type|loan_tenure|risk_appetite|relationship|buss_premise_ownership|company_sector'})
        } else if (res?.data?.success === false) {
            addToast({message: res?.data?.message, status: 'error'})
        }
        }).catch((error) => {
        addToast({message: error, status: 'error'})
        setIsLoading(false)
    })
    } else if (inputValues?.pan?.length !== 10) {
      addToast({ message: 'Please Enter Pan Number', status: 'error' })
    }
  }

  const handleSwitch = (e) => {
let CheckSwitch =e.target.checked
    setCheckSwitch(CheckSwitch)
    setItem('switch', CheckSwitch)
    setCheckAddress(false)
  }

  const handleCheckAddress = (e) => {
    setCheckAddress(e.target.checked)
  }
  const handleCheckAddharnumber = (e) => {
    // setCheckAddharnum(e.target.checked)
    const isSame = e.target.checked;

  setCheckAddharnum(isSame); // checkbox state

  const updatedValues = {
    ...inputValues,
    is_aadhar_mobile_num_same: isSame,
  };

  if (isSame) {
    updatedValues.aadhar_mobile_number = props?.userData?.mobile || '';
  }

  setInputValues(updatedValues);
  }
  const handleBusinessAddress = (e) => {
    setCheckBusinessAddress(e.target.checked)
  }

  const handleSelectInvestment = (val) => {
    const names = val?.map((item) => { return item.key })
    const values = names.join(",")
    setInvestmentValue(values)
  }

  const handleAadharDigilocker = () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (!savedLocation) {
      addToast({ message: 'Please enable Your location in your browser settings to continue.', status: 'error' })
      return
    }
    if (!emailPattern.test(inputValues.email)) {
      addToast({ message: 'Please Enter a Valid Email', status: 'error' })
      return
    }
    if (props?.userData?.employment_type === '1' || props?.userData?.employment_type === '2' || props?.userData?.employment_type === '3') {
      if (!inputValues?.pan) {
        addToast({ message: 'Please Verify Pan First', status: 'error' })
        return
      }
    }
    if (props?.userData?.employment_type === '4' || props?.userData?.employment_type === '5' || props?.userData?.employment_type === '8' || props?.userData?.employment_type === '10') {
      if (!inputValues?.legal_name || !inputValues?.first_name) {
        addToast({ message: 'Please Verify Pan First', status: 'error' })
        return
      }
    }
    setItem('switch', false) 
    props.actions.createDigiLockerAction()
  }

  const handleNext = () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(inputValues?.email)) {
      addToast({ message: 'Please Enter a Valid Email', status: 'error' })
      return
    }
    if (!inputValues?.otp) {
      addToast({ message: 'Please Verify Email First', status: 'error' });
      return
    }
    if (!inputValues?.first_name) {
      addToast({ message: 'Please Enter Your First Name', status: 'error' })
      return
    }
    if (!inputValues?.dob) {
      addToast({ message: 'Please Enter Your Date Of Birth ', status: 'error' })
      return
    } 
    if (!inputValues?.aadhar_mobile_number && checkAddharnum ===false) {
      addToast({ message: 'Please Check Your Addhaar mobile number ', status: 'error' })
      return
    }
    if (props?.userData?.employment_type === '1' || props?.userData?.employment_type === '2' || props?.userData?.employment_type === '3') {
    
     
      if (!inputValues?.pan) {
        addToast({ message: 'Please Verify Pan First', status: 'error' })
        return
      }
    }
    if (!props?.userData?.digi_locker || props?.userData?.digi_locker?.status === 'requested') {
      if (!inputValues?.aadhar_number) {
        addToast({ message: 'Please Enter Aadhaar Number', status: 'error' });
        return
      } else if (!inputValues?.fatherName) {
        addToast({ message: 'Please Enter Fathers Name', status: 'error' });
        return
      } else if (!inputValues?.address_houseNumber || !inputValues?.address_subdistrict) {
        addToast({ message: 'Please Enter House Number & Full Address', status: 'error' });
        return
      } else if (!inputValues?.gender) {
        addToast({ message: 'Please Select Gender', status: 'error' });
        return
      } else if (!inputValues?.address_pincode) {
        addToast({ message: 'Please Enter Pin Code', status: 'error' });
        return
      }
    }
    if(props?.rejectData_user?.v2_aadhar_approved == 1 && (props?.userData?.digi_locker?.status === 'requested' || props?.userData?.digi_locker == null)){
        addToast({ message: 'Please Verify Your Aadhar', status: 'error' });
        return
    }
      if(props?.userData?.employment_type == "1" || props?.userData?.employment_type == "2"){
        if ( inputValues?.premise_status == "0" || !inputValues?.premise_status ) {
          addToast({ message: 'Please Select Ownership', status: 'error' });
          return
        }
        if (inputValues?.educational_qualification == "0" || !inputValues?.educational_qualification ) {
          addToast({ message: 'Please Select Education Qualification', status: 'error' });
          return
        }
      }
  if(userType == '2'){
    if (!inputValues?.alternate_name) {
      addToast({message: 'Please Enter Your alternate Name', status: 'error'})
      return
    }
    if (inputValues?.alternate_mobile?.length !== 10) {
      addToast({message: 'Please Enter Valid Mobile Number', status: 'error'})
      return
    }
    if((checkanothermob ==false)){
        addToast({message: 'Please Verify Your number', status: 'error'})
      return
    }
   
    if (!inputValues?.alternate_addressline1) {
      addToast({message: 'Please Enter Your Alternate Address', status: 'error'})
      return
    }
    if (!inputValues?.alternate_addressline2) {
      addToast({message: 'Please Enter Your Alternate Address', status: 'error'})
      return
    }
    if (!inputValues?.alternate_address_district) {
      addToast({message: 'Please Enter Your Alternate City', status: 'error'})
      return
    }
    if (!inputValues?.alternate_address_state) {
      addToast({message: 'Please Enter Your Alternate State', status: 'error'})
      return
    }
    if (!inputValues?.alternate_address_pincode) {
      addToast({message: 'Please Enter Valid Your Alternate Pincode', status: 'error'})
      return
    }
    if (!inputValues?.alternate_relationship) {
      addToast({message: 'Please Select Your Relation With ', status: 'error'})
      return
    }
  }
     
    
    if (userType === '3') {
      if (!investmentValue) {
        addToast({ message: 'Please Select Investment Type', status: 'error' });
        return
      }
      if (!inputValues?.pref_amount) {
        addToast({ message: 'Please Select Amount', status: 'error' });
        return
      }
      if (!inputValues?.pref_tenure) {
        addToast({ message: 'Please Select Tenure', status: 'error' });
        return
      }
      if (!inputValues?.pref_risk_appetite) {
        addToast({ message: 'Please Select Risk Appetite', status: 'error' });
        return
      }
    }
    // if (!checkAddharnum) {
    //   if (!inputValues?.checkAddharnum) {
    //     addToast({ message: 'Please S, status', status:'error' });
    //     return
    //   } 
    // }
  
  
    if (!inputValues?.current_address || !inputValues?.current_addressline2) {
      addToast({ message: 'Please Enter Current Full Address', status: 'error' });
      return
    } 
    // else if (!inputValues?.current_pincode) {
    //   addToast({ message: 'Please Enter Current Pin Code', status: 'error' });
    //   return
    // }
    // else if (!inputValues?.current_city) {
    //   addToast({ message: "Please Enter Your Current City", status: 'error' });


    // }
    // else if (!inputValues?.current_state) {
    //   addToast({ message: "Please Enter Your Current State.", status: 'error' });


    // }
    if (props?.userData?.employment_type === '4' || props?.userData?.employment_type === '5' || props?.userData?.employment_type === '8'  || props?.userData?.employment_type === '10') {
     if(!inputValues?.pan){
      addToast({ message: 'Please Verify Pan First', status: 'error' })
      return
     }
      if (!inputValues?.legal_name) {
        addToast({ message: 'Please Enter Your Authorized Name', status: 'error' })
        return
     }
     if(props?.userData?.employment_type === '8' ||  props?.userData?.employment_type === '10' ){
      if(!inputValues?.gst){
        addToast({ message: 'Please Enter Gst Number ', status: 'error' });
        return
      }
     }
     if(props?.userData?.employment_type === 8 ||  props?.userData?.employment_type === '10' || props?.userData?.employment_type === '9' ||  props?.userData?.employment_type === '6' ){
      if (!inputValues?.registered_address) {
        addToast({ message: 'Please Enter You Register Address ', status: 'error' });
        return
      }
      if (!inputValues?.state) {
        addToast({ message: 'Please Enter Your Register State ', status: 'error' });
        return
      }
      if (!inputValues?.pincode) {
        addToast({ message: 'Please Enter Your Register Pincode ', status: 'error' });
        return
      }
     }
     if(props?.userData?.employment_type === "4" || props?.userData?.employment_type === "5"  ){
      if (!inputValues?.company_reg_address) {
        addToast({ message: 'Please Enter You Register Address ', status: 'error' });
        return
      }
      if (!inputValues?.company_reg_pincode) {
        addToast({ message: 'Please Enter Your  Register Pincode ', status: 'error' });
        return
      }
     }
      
      if (!checkBusinessAddress) {
        if (!inputValues?.company_buss_address) {
          addToast({ message: 'Please Enter  Business Address', status: 'error' });
          return
        } else if (!inputValues?.company_buss_pincode) {
          addToast({ message: 'Please Enter  Business Pincode', status: 'error' });
          return
        }
      }
    }
    if(props?.userData?.employment_type == '8'){
      if(!inputValues?.company_buss_sector){
        addToast({ message: 'Please Enter Your Business Sector ', status: 'error' });
        return
      }
    }   

    const formData = new FormData()

    let personalData = {
      aadhar_number: inputValues?.aadhar_number ?? props?.userData?.aadhar_card_data?.aadhar_number,
      address_district: inputValues?.address_district ?? props?.userData?.aadhar_card_data?.address_district,
      address_houseNumber: inputValues?.address_houseNumber ?? props?.userData?.aadhar_card_data?.address_houseNumber,
      address_subdistrict: inputValues?.address_subdistrict ?? props?.userData?.aadhar_card_data?.address_subdistrict,
      address_pincode: inputValues?.address_pincode ?? props?.userData?.aadhar_card_data?.address_pincode,
      address_state: inputValues?.address_state ?? props?.userData?.aadhar_card_data?.address_state,
      current_address: inputValues?.current_address ?? props?.userData?.personal_data?.current_address,
      current_addressline2: inputValues?.current_addressline2 ?? props?.userData?.personal_data?.current_addressline2,
      current_city: currentLocation.district ?? props?.userData?.personal_data?.current_city,
      current_pincode: currentLocation.pincode?? props?.userData?.personal_data?.current_pincode,
      current_state: currentLocation.state ?? props?.userData?.personal_data?.current_state,
      dob: inputValues?.dob ?? props?.userData?.dob,
      is_current_address_same : ((isCurrentSame === true && checkAddress === false) ? 1 : 0 ),
      email: inputValues?.email ?? props?.userData?.email,
      father_name: inputValues?.fatherName ?? props?.userData?.aadhar_card_data?.fatherName,
      first_name: inputValues?.first_name ?? props?.userData?.first_name,
      middle_name: inputValues?.middle_name ?? props?.userData?.middle_name,
      last_name: inputValues?.last_name ?? props?.userData?.last_name,
      gender: inputValues?.gender ?? props?.userData?.aadhar_card_data?.gender,
      pan: inputValues?.pan ?? props?.userData?.pan,
      status: 1,
      company_buss_sector: inputValues?.company_buss_sector ?? props?.userData?.personal_data?.company_buss_sector,
      is_aadhar_mobile_num_same: checkAddharnum ? true : false,
      platform:"web",
      isMobile:0,
      aadhar_mobile_number:  inputValues?.aadhar_mobile_number  || (inputValues?.is_aadhar_mobile_num_same && props?.userData?.mobile ) || props?.userData?.personal_data?.aadhar_mobile_number,
    }

    let commonObj; // common object for investor and borrower

    if (userType === '2') {
      if(props?.userData?.employment_type == 1 || props?.userData?.employment_type ==2) {
        commonObj = {
          ...personalData,
          premise_status: inputValues?.premise_status ?? props?.userData?.personal_data?.premise_status,
          educational_qualification: inputValues?.educational_qualification ?? props?.userData?.personal_data?.educational_qualification,
          alternate_addressline1:inputValues?.alternate_addressline1 ?? anotheradd_details[0]?.address_line1  ,
          alternate_addressline2:inputValues?.alternate_addressline2 ?? anotheradd_details[0]?.address_line1 ,
          alternate_address_district:inputValues?.alternate_address_district ?? anotheradd_details[0]?.address_district  ,
          alternate_address_state:inputValues?.alternate_address_state ?? anotheradd_details[0]?.alternate_address_state  ,
          alternate_address_pincode:inputValues?.alternate_address_pincode ?? anotheradd_details[0]?.address_pincode  ,
          alternate_relationship:inputValues?.alternate_relationship ??anotheradd_details[0]?.relationship  ,
          alternate_name:inputValues?.alternate_name ?? anotheradd_details[0]?.name,
          alternate_mobile:inputValues?.alternate_mobile ?? anotheradd_details[0].mobile,
        }

        }
     else{
      commonObj = {
        ...personalData,
        educational_qualification: inputValues?.educational_qualification ?? props?.userData?.personal_data?.educational_qualification,
        legal_name: inputValues?.legal_name ?? props?.userData?.legal_name,
        aadhar_dob: inputValues?.aadhar_dob ?? props?.userData?.aadhar_card_data?.dob,
        gst: inputValues?.gst ?? props?.userData?.gst,
        company_reg_address: inputValues?.registered_address ??  gstData?.registered_address ?? props?.userData?.gst_detail?.registered_address ?? props?.userData?.personal_data?.company_reg_address ,
        company_reg_pincode: inputValues?.pincode ?? gstData?.pincode ?? props?.userData?.gst_detail?.pincode ?? props?.userData?.personal_data?.company_reg_pincode,
        company_reg_state: inputValues?.state ??  gstData?.state ?? props?.userData?.gst_detail?.state  ?? props?.userData?.personal_data?.company_reg_state ,
        company_buss_state: inputValues?.company_buss_state ?? props?.userData?.personal_data?.company_buss_state,
        company_buss_pincode: inputValues?.company_buss_pincode ?? props?.userData?.personal_data?.company_buss_pincode,
        company_buss_address: inputValues?.company_buss_address ?? props?.userData?.personal_data?.company_buss_address,
        authorised_signatory:inputValues?.authorised_signatory ?? props?.userData?.authorised_signatory,
        is_business_address_same: checkBusinessAddress ? true : false,
        company_buss_sector:inputValues?.company_buss_sector ?? props?.userData?.personal_data?.company_buss_sector,
        alternate_addressline1:inputValues?.alternate_addressline1 ?? anotheradd_details[0]?.address_line1  ,
        alternate_addressline2:inputValues?.alternate_addressline2 ?? anotheradd_details[0]?.address_line1 ,
        alternate_address_district:inputValues?.alternate_address_district ?? anotheradd_details[0]?.address_district  ,
        alternate_address_state:inputValues?.alternate_address_state ?? anotheradd_details[0]?.alternate_address_state  ,
        alternate_address_pincode:inputValues?.alternate_address_pincode ?? anotheradd_details[0]?.address_pincode  ,
        alternate_relationship:inputValues?.alternate_relationship ??anotheradd_details[0]?.relationship  ,
        alternate_name:inputValues?.alternate_name ?? anotheradd_details[0]?.name,
        alternate_mobile:inputValues?.alternate_mobile ?? anotheradd_details[0].mobile,
      }
     }
    }
    else if (userType === '3') {
      commonObj = {
        ...personalData,
        pref_amount: inputValues?.pref_amount ?? props?.userData?.preference_data?.amount,
        pref_investment_types: investmentValue ? investmentValue : '',
        pref_risk_appetite: inputValues?.pref_risk_appetite ?? props?.userData?.preference_data?.risk_appetite,
        pref_tenure: inputValues?.pref_tenure ??  props?.userData?.preference_data?.tenure,
        // legal_name: inputValues?.legal_name ?? props?.userData?.legal_name
        legal_name: inputValues?.legal_name ?? props?.userData?.legal_name,
        aadhar_dob: inputValues?.aadhar_dob ?? props?.userData?.aadhar_card_data?.dob,
        gst: inputValues?.gst ?? props?.userData?.gst,
        company_reg_address: inputValues?.company_reg_address ?? props?.userData?.personal_data?.company_reg_address,
        company_reg_pincode: inputValues?.company_reg_pincode ?? props?.userData?.personal_data?.company_reg_pincode,
        company_reg_state: inputValues?.company_reg_state ?? props?.userData?.personal_data?.company_reg_state,
        company_buss_state: inputValues?.company_buss_state ?? props?.userData?.personal_data?.company_buss_state,
        company_buss_pincode: inputValues?.company_buss_pincode ?? props?.userData?.personal_data?.company_buss_pincode,
        company_buss_address: inputValues?.company_buss_address ?? props?.userData?.personal_data?.company_buss_address,
        is_business_address_same: checkBusinessAddress ? true : false,
      }
    }
    props.actions.postPersonalDetailsAction(commonObj)

  }



  const isReject = props?.userData?.document_data?.doc_approval_status === 1
  const rejectData = (props?.userData?.user_document_checked_data?.document && JSON.parse(props?.userData?.user_document_checked_data?.document))
  return (
    <>
      {(kycState?.postPersonalDetails?.loading || masterState?.getCurrentUserDetails?.loading || loading || isLoading ||
        masterState?.getDropdownData?.loading) &&
        <div>
          <Loader />

        </div>
      }
      {/* {showPermissionPopup && (
      <CustomModal
        title="Location Access Denied"
        message="Please enable location access in your browser settings to continue."
        onClose={() => setShowPermissionPopup(false)}
      />
    )} */}
      <Box className='main_form_container'>
        <Grid className="grid_container">
          <GridItem>
            <Heading as="h1" mb={7} className="font-poppins text_heading">Fill your Personal Details</Heading>
            <Box mb={7} className='form_kyc'>
            <Heading as="h1" className="font-poppins label_heading" mb={3}>Email Address</Heading>
                <Box mb={3}>
                  <InputGroup>
                    {verifyStatus || props?.userData?.email ?
                      <InputRightElement pointerEvents="none" children={<CheckCircleIcon className='verify_icon' />} /> : null}
                    <Input
                      type="email"
                      size="md"
                      id="email"
                      name="email"
                      placeholder="Verify Email Address*"
                      onChange={handleChange}
                      className="input_box font-poppins bg_white"
                      value={inputValues?.email ?? props?.userData?.email ?? ''}
                      isReadOnly={props?.userData?.email || otpStatus}
                    />
                  </InputGroup>
                </Box>
                {!props?.userData?.email ?
                  <>
                    {!verifyStatus ?
                      <>
                        <Box mb={3} className="right_align">
                          {otpStatus ?
                            <Flex className="right_align resend">
                              <CustomButton size="md" type="submit" title="Resend OTP" className="font-poppins btn_transparent" onClick={handleResendOTP}
                                isDisabled={timerCount === 0 ? false : true} />
                              {timerCount === 0 ? null : <Heading as="p"> {timerCount} Sec </Heading>}
                            </Flex>
                            :
                            <CustomButton size="md" type="submit" title="Get OTP" className="font-poppins btn_transparent" onClick={() => handleOTP()} />
                          }
                        </Box>
                        <Box mb={3}>
                          <Input
                            size="md"
                            id="otp"
                            name="otp"
                            type="number"
                            disabled={!otpStatus}
                            isReadOnly={verifyStatus}
                            placeholder="Enter Otp"
                            onChange={handleChange}
                            className="input_box font-poppins bg_white"
                            value={inputValues?.otp ?? ''}
                          />
                        </Box>
                      </> : null}
                  </> : null}
              <Box mt={7}>
                          { (props?.userData?.employment_type == 4 || props?.userData?.employment_type == 5 || props?.userData?.employment_type ==  '10' || props?.userData?.employment_type ==  '8'   ) &&
                          <>
                                  <Heading as="h1" className="font-poppins label_heading" mb={3}>Company Name</Heading>
                                        <Input
                                          mb={5}
                                          type="text"
                                          size="md"
                                          name="first_name"
                                          placeholder="Company Name"
                                          onChange={handleChange}
                                          className="input_box font-poppins bg_white"
                                          value={inputValues?.first_name ?? props?.userData?.first_name ?? ''}
                                         isReadOnly={props?.userData?.first_name?.length >0 || panData} 

                                        />
                                         <Heading as="h1" className="font-poppins label_heading" mb={3}>Authorizer Name</Heading>
                                        <Input
                                          mb={5}
                                          type="text"
                                          size="md"
                                          name="legal_name"
                                          placeholder="Enter Your Authorized Name"
                                          onChange={handleChange}
                                          className="input_box font-poppins bg_white"
                                          value={inputValues?.legal_name ?? props?.userData?.legal_name ?? ''}
                                           isReadOnly={props?.userData?.legal_name?.length >0} 
                                       
                                       />
                          </>
                       }
                          { (props?.userData?.employment_type == 1 || props?.userData?.employment_type == 2 || props?.userData?.employment_type ==  '3' || props?.userData?.employment_type ==  '7'  ||  props?.userData?.employment_type ==  '6' || props?.userData?.employment_type ==  '9' ) &&
                          <>
                          <Heading as="h1" className="font-poppins label_heading" mb={3}>First Name</Heading>
                          <Input
                                        mb={5}
                                        type="text"
                                        size="md"
                                        name="first_name"
                                        placeholder="First Name"
                                        onChange={handleChange}
                                        className="input_box font-poppins bg_white"
                                        value={inputValues?.first_name ?? props?.userData?.first_name?? ''}
                                       isReadOnly={props?.userData?.first_name?.length >0 || panData} 

                                        />
                                            <Heading as="h1" className="font-poppins label_heading" mb={3}>Middle Name</Heading>
                        <Input
                            mb={5}
                            type="text"
                            size="md"
                            name="middle_name"
                            placeholder="Middle Name"
                            onChange={handleChange}
                            className="input_box font-poppins bg_white"
                            value={inputValues?.middle_name ?? props?.userData?.middle_name ?? ''}
                            isReadOnly={props?.userData?.middle_name?.length >0 || panData || props?.userData?.personal_data?.status==1 } 

                        />
                          <Heading as="h1" className="font-poppins label_heading" mb={3}>Last Name</Heading>
                        <Input
                            mb={5}
                            type="text"
                            size="md"
                            name="last_name"
                            placeholder="Last Name"
                            onChange={handleChange}
                            className="input_box font-poppins bg_white"
                            value={inputValues?.last_name ?? props?.userData?.last_name ?? ''}
                            isReadOnly={props?.userData?.last_name?.length > 0 || panData  || props?.userData?.personal_data?.status==1} 
                            
                        />
                          
                          </>
                                        
                          }  
                      
                    
                                 {
                        (props?.userData?.employment_type === '7' ||  props?.userData?.employment_type === '10' ) ?
                        <Heading as="h1" className="font-poppins label_heading" mb={3}>Firm Registeration Date</Heading>
                        
                        :
                        (props?.userData?.employment_type === '6' || props?.userData?.employment_type === '9') ?
                      <Heading as="h1" className="font-poppins label_heading" mb={3}>Proprietor Registeration Date</Heading>
                        :
                      <Heading aas="h1" className="font-poppins label_heading" mb={3}>Date of Birth</Heading>

                      }
                        <Input
                            mb={5}
                            type="date"
                            size="md"
                            name="dob"
                            placeholder="Date of Birth"
                            onChange={handleChange}
                            className="input_box font-poppins bg_white"
                            value={inputValues?.dob ?? props?.userData?.dob ?? ''}
                        isReadOnly={props?.userData?.dob?.length >0 || panData } 

                        />
             
              </Box>
  
              <Box mt={7} className='pan_box'>
              <Heading as="h1" className="font-poppins label_heading" mb={3}>
                  {props?.userData?.employment_type === '1' || props?.userData?.employment_type === '2' || props?.userData?.employment_type === '3'
                    ? 'PAN Number'
                    : props?.userData?.employment_type === '4' || props?.userData?.employment_type === '5' || props?.userData?.employment_type === '8'
                    ? 'PAN Number Of The Company'
                    : (props?.userData?.employment_type === '6' ||props?.userData?.employment_type === '9' )
                    ? 'PAN of the Proprietor'
                    : (props?.userData?.employment_type === '7' || props?.userData?.employment_type === '10')
                    ? 'PAN of the Firm'
                    : ''}
                </Heading>
                {(props?.userData?.employment_type === '4' || props?.userData?.employment_type === '5' || props?.userData?.employment_type === '8' || props?.userData?.employment_type === '10') ?
                  <InstitutionalPan inputValues={inputValues} userData={props?.userData} panData={panData} handleChange={handleChange} handleVerifyPan={handleVerifyPan} /> :
                  <Box mb={3}>
                    <InputGroup>
                      <Input
                        type="text"
                        size="md"
                        name="pan"
                        placeholder="Enter PAN Number"
                        onChange={handleChange}
                        className="input_box font-poppins bg_white"
                        value={inputValues?.pan ?? props?.userData?.pan ?? ''}
                        isReadOnly={props?.userData?.pan || panData || !props?.userData?.email} 
                      />
                      {props?.userData?.is_pan_verified === 1 || panData ?
                        <InputRightElement pointerEvents="none" children={<CheckCircleIcon className='verify_icon' />} /> :
                        <CustomButton size="md" type="submit" title="Verify" className="font-poppins btn_link" onClick={() => handleVerifyPan()} />
                      }
                    </InputGroup>
                  </Box>
                }
              </Box>
              {/* <Box mt={3}>
                        <Heading as="h1" className="font-poppins label_heading" mb={3}> Is Your Registered Mobile Number Your Aadhaar Number</Heading>
                        <Input
                            mb={5}
                            type="text"
                            size="md"
                            name="aadhar_mobile_number"
                            placeholder="Please Enter Your  Mobile Number Linked with Aadhaar"
                            onChange={handleChange}
                            className="input_box font-poppins bg_white"
                            value={inputValues?.aadhar_mobile_number ?? props?.userData?.personal_data?.aadhar_mobile_number ?? ''}
                        />
                        </Box>  */}
                        <Box mt={5}>
                <Box className="checkbox_item" >
                    <Checkbox onChange={(e) => handleCheckAddharnumber(e)} isChecked={checkAddharnum}>
                    Is Your Registered Mobile Number Same As Your Aadhaar Number
                    </Checkbox>
                </Box>
                {!checkAddharnum ?
                <>
                    <Box mt={3}>
                        <Heading as="h1" className="font-poppins label_heading" mb={3}>Aadhaar Mobile Number</Heading>
                        <Input
                            mb={5}
                            type="text"
                            size="md"
                            name="aadhar_mobile_number"
                            placeholder="Please Enter Your  Mobile Number Linked with Aadhaar"
                            onChange={handleChange}
                            className="input_box font-poppins bg_white"
                            value={inputValues?.aadhar_mobile_number ?? props?.userData?.personal_data?.aadhar_mobile_number ?? ''}
                            onKeyDown={preventInvalidKey}
                       disabled={( adhaarmobileData?.success == true || props?.userData?.personal_data?.aadhar_mobile_number) ? true :false }
                            onWheel={(e) => e.target.blur()}
                        />
                        <Box mt={5} className="right_align">
                     {((requestIdAddhaarUser && isgetotp_adhaar === true) || adhaarmobileData?.success == false) &&
                       <Flex className="right_align resend">
                         <CustomButton size="md" type="submit" title="Resend OTP" className="font-poppins btn_transparent" onClick={handlAadharMobResendOTP}
                           isDisabled={(timerCount === 0 || adhaarmobileData?.duplicateFlag == true) ? false : true} />
                         {timerCount === 0 ? null : <Heading as="p" disabled={authState?.verifyMobileOTP?.data?.success == true}  > {timerCount} Sec </Heading>}
                       </Flex>

                     }
                     {(adhaarmobilefield === false && !props?.userData?.personal_data?.aadhar_mobile_number) &&
                       <CustomButton size="md" type="submit" title="Get OTP" className="font-poppins btn_transparent" onClick={() => adhaarhandleOTP()} />

                     }

                   </Box>
                   {
                     adhaarotpfield === true &&
                     <Box mt={5}>
                       <Input
                         size="md"
                         id="adhaarmobile_otp"
                         name="adhaarmobile_otp"
                         type="number"
                         disabled={!requestIdAddhaarUser || adhaarmobileData?.success === true}
                         placeholder="Mobile OTP"
                         onChange={handleChange}
                         className="input_box font-poppins"
                         value={inputValues?.adhaarmobile_otp ?? ''}
                         onKeyDown={preventInvalidKey}
                         onWheel={(e) => e.target.blur()}
                       />
                     </Box>
                   }
                    </Box>
                </> : null}
                </Box>
              <Box mt={7}>
                      {/* <Box style ={{marginTop:"0px",marginRight:"110px"}}className=' align-items-center justify-content-between reject_block'> */}
                  <Heading as="h1" className="font-poppins label_heading" mb={4}>
                          {props?.userData?.employment_type === '4' || props?.userData?.employment_type === '5' || props?.userData?.employment_type === '8'
                            ? 'Aadhaar Details (Promoter/ Director)'
                            : props?.userData?.employment_type === '3' || props?.userData?.employment_type === '2' || props?.userData?.employment_type === '1'
                            ? 'Aadhaar Details'
                            : (props?.userData?.employment_type === '6' || props?.userData?.employment_type === '9')
                            ? 'Aadhar Number of the proprietor'
                            :(props?.userData?.employment_type === '7' || props?.userData?.employment_type === '10')
                            ? 'Aadhar Number Of The Major Partner'
                            : ''}
                            {rejectData?.v2_aadhar_reject_reason &&
                            <Text className="align-items-center justify-content-between reject_block" style={{color:"red",fontSize:"10px"}}>Admin Comment
                              <Tooltip label={rejectData?.v2_aadhar_reject_reason}
                                hasArrow fontSize='xs' placement='bottom-start'>
                                <InfoOutlineIcon />
                              </Tooltip>
                            </Text>
                          }
                        </Heading>
                {props?.userData?.digi_locker?.status === 'approved' &&
                  <Box mb={3}>
                    <InputGroup>
                      <Input
                        type="text"
                        size="md"
                        className="input_box font-poppins bg_white"
                        value={props?.userData?.aadhar_card_data?.aadhar_number}
                        isReadOnly={props?.userData?.aadhar_card_data?.aadhar_number}
                      />
                      <InputRightElement pointerEvents="none" children={<CheckCircleIcon className='verify_icon' />} />
                    </InputGroup>
                    <Box className='verified_data'>
                      {props?.userData?.aadhar_card_data?.gender ? <Heading as="p" className='font-poppins'><b>Gender:</b> {props?.userData?.aadhar_card_data?.gender}</Heading> : null}
                      {props?.userData?.aadhar_card_data?.fatherName ? <Heading as="p" className='font-poppins'><b>Guardian's Name:</b> {props?.userData?.aadhar_card_data?.fatherName}</Heading> : null}
                      <Heading as="p" className='font-poppins'><b>Address:</b> {props?.userData?.aadhar_card_data?.address_houseNumber}</Heading>
                    </Box>
                    {props?.userData?.aadhar_card_data?.fatherName ? null :
                      <Box mt={3}>
                        <Heading as="h1" className="font-poppins label_heading" mb={3}>Guardian's Name{' '}{' '}{' '}{' '}
                          <Tooltip label='Your Father Name Here' fontSize='md'>
                            <InfoOutlineIcon />
                          </Tooltip>
                        </Heading>
                        <Input
                          type="text"
                          size="md"
                          name="fatherName"
                          placeholder="Enter Guardian's Name"
                          onChange={handleChange}
                          className="input_box font-poppins bg_white"
                          value={inputValues?.fatherName ?? props?.userData?.aadhar_card_data?.fatherName ?? ''}
                          isReadOnly={props?.userData?.aadhar_card_data?.fatherName}
                        />
                      </Box>}
                    {!props?.userData?.aadhar_card_data?.gender ?
                      <Box className='w-100' mt={5}>
                        <Heading as="h1" className="font-poppins label_heading" mb={3}>Gender</Heading>
                        <Select placeholder="Select Gender" name="gender" variant="filled" onChange={handleChange}
                          className="input_box_select font-poppins bg_white" value={inputValues?.gender ?? props?.userData?.aadhar_card_data?.gender ?? ''}>
                          {genderData?.map((item) => {
                            return (
                              <option key={item.id} value={item.id}>{item.name}</option>
                            )
                          })}
                        </Select>
                      </Box> : null}
                  </Box> }
                  {((rejectData?.v2_aadhar_approved ==1 && props?.userData?.digi_locker?.status === 'requested') || props?.userData?.digi_locker == null || props?.userData?.digi_locker?.status === 'requested') && (
                      <CustomButton
                        size="md"
                        type="submit"
                        title="Verify via Digilocker"
                        onClick={handleAadharDigilocker}
                        className="font-poppins btn_theme"
                        isDisabled ={(checkAddharnum  === true  || props?.userData?.personal_data?.aadhar_mobile_number || checkfieldAddharnum ==true) ? false :true}
                      />
                    )}
              </Box>
              {
                   displayCurrentAddressField ==true &&
                   <Box mt={5}>
                   {/* <Box className="checkbox_item" >
                       <Checkbox onChange={(e) => handleCheckAddress(e)} isChecked={checkAddress}>
                           My Current address is same as My Aadhar Address
                       </Checkbox>
                   </Box> */}

                  {/* personal_data?.status ==1 */}
                 
                       <Box mt={3}>
                           <Heading as="h1" className="font-poppins label_heading" mb={3}>Current Address</Heading>
                           <Input
                               mb={5}
                               type="text"
                               size="md"
                               name="current_address"
                               placeholder="Aadhaar Address Line 1"
                               onChange={handleChange}
                               className="input_box font-poppins bg_white"
                               value={inputValues?.current_address ?? props?.userData?.personal_data?.current_address ?? ''}
                           />
                           <Input
                               type="text"
                               size="md"
                               name="current_addressline2"
                               placeholder="Enter Your House Number"
                               onChange={handleChange}
                               className="input_box font-poppins bg_white"
                               value={inputValues?.current_addressline2 ?? props?.userData?.personal_data?.current_addressline2 ?? ''}
                           />
                       </Box>
                       <Box mt={7}>
                           <Heading as="h1" className="font-poppins label_heading" mb={3}>Pin Code</Heading>
                           <Input
                               type="number"
                               size="md"
                               name="current_pincode"
                               placeholder="Enter Pin Code"
                               onChange={handleChange}
                               className="input_box font-poppins bg_white"
                               value={currentLocation?.pincode ?? props?.userData?.personal_data?.current_pincode ?? ''}
                               onKeyDown={preventInvalidKey}
                               isDisabled={(pincodeField || props?.userData?.personal_data?.current_pincode || currentLocation.pincode )? true :false}
                           />
                       </Box>
                       <Flex mt={7} className='col-gap'>
                           <Box className='w-100'>
                               <Heading as="h1" className="font-poppins label_heading" mb={3}>City</Heading>
                               <Input
                                   type="text"
                                   size="md"
                                   name="current_city"
                                   isReadOnly={true}
                                   placeholder="Enter City"
                                   onChange={handleChange}
                                   className="input_box font-poppins bg_white"
                                   value={currentLocation?.district ?? props?.userData?.personal_data?.current_city ?? ''}
                               />
                           </Box>
                           <Spacer />
                           <Box className='w-100'>
                               <Heading as="h1" className="font-poppins label_heading" mb={3}>State</Heading>
                               <Input
                                   type="text"
                                   size="md"
                                   name="current_state"
                                   isReadOnly={true}
                                   placeholder="Enter State"
                                   onChange={handleChange}
                                   className="input_box font-poppins bg_white"
                                   value={currentLocation?.state ?? props?.userData?.personal_data?.current_state ?? ''}
                               />
                           </Box>
                       </Flex>
                 </Box>
              }
             
            </Box>
          </GridItem>
          {userType === '2' ?
            <GridItem>
              {
                (props?.userData?.employment_type == "2" || props?.userData?.employment_type  == "1") &&
                  <>
                  <Box mt={7} className='form_kyc'>
                <Heading as="h1" className="font-poppins label_heading" mb={3}>House Ownership</Heading>
                <Select placeholder="Select Your Ownership" name="premise_status" variant="filled" onChange={handleChange}
                  className="input_box_select font-poppins bg_white"
                  // value={inputValues?.premise_status ?? (props?.userData?.personal_data?.premise_status =="0" ? null : props?.userData?.personal_data?.premise_status)?? ''}
                  value={
                    inputValues?.premise_status ??
                    (props?.userData?.personal_data?.premise_status === "0" ? null : props?.userData?.personal_data?.premise_status) ??
                    ""
                  }
                  >
                  {premiseStatusOptions?.map((item) => {
                    return (
                      <option key={item.key} value={item.key}>{item.value}</option>
                    )
                  })}
                </Select>
              </Box>
              <Box mt={8} className='form_kyc'>
              <Heading as="h1" className="font-poppins label_heading" mb={3}>Education Qualification</Heading>
              <Select placeholder="Please Select Your Edu. Qualification" name="educational_qualification" variant="filled" onChange={handleChange}
                className="input_box_select font-poppins bg_white"
                value={
                  inputValues?.educational_qualification ??
                  (props?.userData?.personal_data?.educational_qualification === "0" ? null : props?.userData?.personal_data?.educational_qualification) ??
                  ""}
                  >
                {qualificationsOptions?.map((item) => {
                  return (
                    <option key={item.key} value={item.key}>{item.value}</option>
                  )
                })}
              </Select>
               </Box>
                  </>
              }
              <KycLoanDetails inputValues={inputValues} userData={props?.userData} panData={panData} gstData={gstData} handleChange={handleChange} handleVerifyPan={handleVerifyPan} handleBusinessAddress={handleBusinessAddress}  checkBusinessAddress={checkBusinessAddress} dropdownData={dropdownData}/>
              { userType == '2' && anotheradd_details.map(item => {
                 return <>
                   <Box mt={5} className='form_kyc'>
                     {rejectData?.alternate_details_reject_reason &&
                       <Text className="align-items-center justify-content-between reject_block" style={{ color: "red", fontSize: "10px" }}>Admin Comment
                         <Tooltip label={rejectData?.alternate_details_reject_reason}
                           hasArrow fontSize='xs' placement='bottom-start'>
                           <InfoOutlineIcon />
                         </Tooltip>
                       </Text>
                     }

                     <Heading as="h1" className="font-poppins label_heading" mb={3}>Alternate Name</Heading>
                     <Input
                       type="text"
                       size="md"
                       id="alternate_name"
                       name="alternate_name"
                       placeholder="Name"
                       onChange={handleChange}
                       className="input_box font-poppins"
                       value={inputValues?.alternate_name ?? item?.name ?? ''}
                       onKeyDown={validateAlphaNumeric}
                       onWheel={(e) => e.target.blur()}
                     />
                   </Box>
                   <Box mt={5} className='form_kyc'>
                     <Heading as="h1" className="font-poppins label_heading" mb={3}>Alternate Mobile</Heading>

                     <Input
                       type="number"
                       size="md"
                       id="alternate_mobile"
                       name="alternate_mobile"
                       placeholder="Mobile Number"
                       onChange={handleChange}
                       disabled={( mobileData?.success == true || props?.userData?.alternate_details?.length > 0) ? true :false }
                       // disabled={(!requestIdUser || mobileData?.success == false) ? false : true}
                       className="input_box font-poppins"
                       value={inputValues?.alternate_mobile ?? item?.mobile ?? ''}
                       onKeyDown={preventInvalidKey}
                       onWheel={(e) => e.target.blur()}
                     />
                   </Box>
                   <Box mt={5} className="right_align">
                     {((requestIdUser && isgetotp === true) || mobileData?.success == false) &&
                       <Flex className="right_align resend">
                         <CustomButton size="md" type="submit" title="Resend OTP" className="font-poppins btn_transparent" onClick={handleMobResendOTP}
                           isDisabled={(timerCount === 0 || mobileData?.duplicateFlag == true) ? false : true} />
                         {timerCount === 0 ? null : <Heading as="p" disabled={authState?.verifyMobileOTP?.data?.success == true}  > {timerCount} Sec </Heading>}
                       </Flex>

                     }
                     {(mobilefield === false && props?.userData?.alternate_details.length ==0) &&
                       <CustomButton size="md" type="submit" title="Get OTP" className="font-poppins btn_transparent" onClick={() => mobilehandleOTP()} />

                     }

                   </Box>
                   {
                     otpfield === true &&
                     <Box mt={5}>
                       <Input
                         size="md"
                         id="otp"
                         name="mobile_otp"
                         type="number"
                         disabled={!requestIdUser || mobileData?.success === true}
                         placeholder="Mobile OTP"
                         onChange={handleChange}
                         className="input_box font-poppins"
                         value={inputValues?.mobile_otp ?? ''}
                         onKeyDown={preventInvalidKey}
                         onWheel={(e) => e.target.blur()}
                       />
                     </Box>
                   }


                   <Box mt={3} className='form_kyc'>
                     <Heading as="h1" className="font-poppins label_heading" mb={3}>Alternate Address</Heading>
                     <Input
                       mb={5}
                       type="text"
                       size="md"
                       name="alternate_addressline1"
                       placeholder="Enter Your House Number"
                       disabled={item?.alternate_addressline1}
                       onChange={handleChange}
                       className="input_box font-poppins bg_white"
                       value={inputValues?.alternate_addressline1 ?? item?.address_line1 ?? ''}
                     />
                     <Input
                       type="text"
                       size="md"
                       name="alternate_addressline2"
                       placeholder="Current Address Line 2"
                       onChange={handleChange}
                       className="input_box font-poppins bg_white"
                       value={inputValues?.alternate_addressline2 ?? item?.address_line2 ?? ''}
                     />
                   </Box>
                   <Box mt={7} className='form_kyc'>
                     <Heading as="h1" className="font-poppins label_heading" mb={3}>Pin Code</Heading>
                     <Input
                       type="number"
                       size="md"
                       name="alternate_address_pincode"
                       placeholder="Enter Pin Code"
                       onChange={handleChange}
                       className="input_box font-poppins bg_white"
                       value={inputValues?.alternate_address_pincode ?? item?.address_pincode ?? ''}
                       onKeyDown={preventInvalidKey}
                     />
                   </Box>
                   <Flex mt={7} className='col-gap'>
                     <Box className='w-100 form_kyc'>
                       <Heading as="h1" className="font-poppins label_heading" mb={3}>City</Heading>
                       <Input
                         type="text"
                         size="md"
                         name="alternate_address_district"
                         isReadOnly={true}
                         placeholder="Enter City"
                         onChange={handleChange}
                         className="input_box font-poppins bg_white"
                         value={inputValues?.alternate_address_district ?? item?.address_district ?? ''}
                       />
                     </Box>
                     <Spacer />
                     <Box className='w-100 form_kyc'>
                       <Heading as="h1" className="font-poppins label_heading" mb={3}>State</Heading>
                       <Input
                         type="text"
                         size="md"
                         name="alternate_address_state"
                         isReadOnly={true}
                         placeholder="Enter State"
                         onChange={handleChange}
                         className="input_box font-poppins bg_white"
                         value={inputValues?.alternate_address_state ?? item?.address_state ?? ''}
                       />
                     </Box>
                   </Flex>
                   <Box mt={8} className='form_kyc'>
                     <Heading as="h1" className="font-poppins label_heading" mb={3}>Relation</Heading>
                     <Select placeholder="Please Select Your Relation" name="alternate_relationship" variant="filled" onChange={handleChange}
                       className="input_box_select font-poppins bg_white"
                       value={
                         inputValues?.alternate_relationship ??
                         (item?.relationship === "0" ? null : item?.relationship) ??
                         ""}
                     >
                       {relationwithuser?.map((item) => {
                         return (
                           <option key={item.key} value={item.key}>{item.value}</option>
                         )
                       })}
                     </Select>
                   </Box>
                 </>
               })
               }
            </GridItem>
            
            
            :
            <GridItem>
              <Heading as="h1" className="font-poppins heading_invest" mb={3}>Your Investment Preferences</Heading>
              <Box mt={7} className='form_kyc'>
                <Heading as="h1" className="font-poppins label_heading" mb={3}>Investment Type</Heading>
                <Multiselect
                  className='multiSelect_box font-poppins'
                  placeholder="Select Your Investment Type"
                  onRemove={handleSelectInvestment}
                  onSelect={handleSelectInvestment}
                  options={investmentType}
                  displayValue="value"
                  selectedValues={selectedValues}
                />
              </Box>
              <Box mt={7} className='form_kyc'>
                <Heading as="h1" className="font-poppins label_heading" mb={3}>Amount</Heading>
                <Input
                  type="number"
                  placeholder="Please Enter Amount"
                  name="pref_amount"
                  variant="filled"
                  onChange={handleChange}
                  className="input_box_select font-poppins bg_white"
                  value={inputValues?.pref_amount ?? props?.userData?.preference_data?.amount ?? ''}
                >
                </Input>
              </Box>
              <Box mt={7} className='form_kyc'>
                <Heading as="h1" className="font-poppins label_heading" mb={3}>Tenure</Heading>
                <Select
                  placeholder="Please Select Tenure"
                  name="pref_tenure"
                  variant="filled"
                  onChange={handleChange}
                  className="input_box_select font-poppins bg_white"
                  value={inputValues?.pref_tenure ?? props?.userData?.preference_data?.tenure ?? ''}
                >
                  {loanTenure?.map((item) => (
                    <option key={item.key} value={item.key}>{item.value}</option>
                  ))}
                </Select>
              </Box>
              <Box mt={7} className='form_kyc'>
                <Heading as="h1" className="font-poppins label_heading" mb={3}>Risk Appetite</Heading>
                <Select
                  placeholder="Please Select"
                  name="pref_risk_appetite"
                  variant="filled"
                  onChange={handleChange}
                  className="input_box_select font-poppins bg_white"
                  value={inputValues?.pref_risk_appetite ?? props?.userData?.preference_data?.risk_appetite ?? ''}
                >
                  {riskAppetite?.map((item) => (
                    <option key={item.key} value={item.key}>{item.value}</option>
                  ))}
                </Select>
              </Box>
              <KycLoanDetails dropdownData={dropdownData}  inputValues={inputValues} userData={props?.userData} panData={panData} handleChange={handleChange} handleVerifyPan={handleVerifyPan} handleBusinessAddress={handleBusinessAddress}  checkBusinessAddress={checkBusinessAddress}/>

            </GridItem>
          }
        </Grid>
        <Box className="kyc_actions">
          <CustomButton size="md" type="submit" title="Next" className="btn_green font-poppins" onClick={handleNext} />
        </Box>
      </Box>
    </>
  )
}
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(ActionCreators, dispatch),
})

export default connect(null, mapDispatchToProps)(PersonalDetails)